export enum Roles {
  CUSTOMER = 'CUSTOMER',
  DELIVERY = 'DELIVERY',
  OPERATOR = 'OPERATOR',
  ADMIN = 'ADMIN',
}
